var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.icon)?_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function({on}){return [_c('v-icon',_vm._g({},on),[_vm._v(_vm._s(_setup.icon))])]}}],null,false,2208365928)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.referenceRate))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }